module.exports = __webpack_public_path__ + "static/media/SolarJuiceCharger.08bebd49.jpg";